import { blue, btnHoverColor, btnTextColor, grey, textColor } from './palette';

export function overrides(theme) {
  return {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          '&.MuiInputLabel-root': {
            top: "-8px"
          }
        }
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          height: '25px'
        }
      }
    },
    MuiChip: {
      styleOverrides: {
        deleteIcon: {
          color: "white",
          //backgroundColor: 'lightblue', // İkonun arka plan rengi
          borderRadius: '50%', // İkonun köşe yuvarlaklığı
          '&:hover': {
            color: 'white', // Hover durumu için arka plan rengi
          },
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        option: {
          '&:hover': {
            backgroundColor: 'lightblue !important', // Hover durumu için arka plan rengi
          },
          '&[aria-selected="true"]': {
            backgroundColor: '#e9f2ff !important',
            color: `${blue[900]} !important`,
          },
          '&[aria-selected="true"].Mui-focused': {
            backgroundColor: '#d6e8ff !important',
            color: `${blue[900]} !important`,
          },
        },
        clearIndicator: {
          color: 'red !important', // Silme butonunun rengi
          '&:hover': {
            // color: 'darkred', // Hover durumu için rengi
          },
        },

      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          height: "auto !important",
        }
      }
    },
    MuiBox: {
      styleOverrides: {
        root: {
          marginBottom: "7px !important"
        },
      },
    },
    MuiPopper: {
      styleOverrides: {
        root: {
          zIndex: "50000000000 !important",
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // İstediğiniz box shadow değeri
        },
      },
      /*      defaultProps: {
             disablePortal: true, // Ensures the Popper stays within the scrollable container
             modifiers: [
               {
                 name: 'preventOverflow',
                 options: {
                   boundary: 'scrollParent', // Prevents overflow within the scrollable parent
                 },
               },
               {
                 name: 'offset',
                 options: {
                   offset: [0, 8], // Adjusts the offset for better positioning
                 },
               },
             ],
           }, */
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          '&.Mui-disabled': {
            WebkitTextFillColor: 'gray', // Disabled metin rengi
            opacity: 0.8, // İsteğe bağlı, görünürlük için
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          zIndex: "20000000000!important"
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          zIndex: "10000 !important",
          backdropFilter: "blur(4px)"
        },
        paper: {
          maxWidth: "500px",
          width: "100% !important"
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: '#ff3333 !important', // Sets helper text color to red
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          color: `${textColor}`,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: '50px',
          minHeight: '50px !important'
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          margin: "0px !important",
          '&:hover': {
            background: "#e9f3ec !important",
            borderRadius: "7px 7px 0 0",
          }
        }
      }
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          position: 'sticky !important',
          margin: "1px 4px !important",
          color: `${textColor} !important`,
          '&.MuiIconButton-root.MuiDataGrid-menuIconButton': {
            color: textColor,
          },
          '&:hover': {
            //background: "#ccd8f4 !important",
            background: `${btnHoverColor} !important`,
            color: `${blue[900]} !important`,
            /*     border:"1px solid #abb7d4" */
          }
        },
        '&:hover': {
          background: `${btnHoverColor} !important`,
          '& .MuiSvgIcon-root': {
            color: 'white', // Hover durumunda iconun rengi beyaz
          },
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          marginTop: "0px !important",
          height: "50px",
          color: textColor,
          fontSize: "11px"
        },
        input: {
          display: "flex !important",
          fontSize: '12px', // İstediğiniz font boyutunu buraya girin
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: textColor,
          '&.Mui-focused': {
            /* color: theme.palette.grey[500], */
            color: textColor
          },
          '&.Mui-disabled': {
            color: theme.palette.grey[500], // Disabled durumda etkilemek için
            // opacity: 0.5
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        selectLabel: {
          color: textColor,
          display: 'block',
          [theme.breakpoints.down('sm')]: {
            display: 'none',
          },
        },
        input: {
          color: textColor,
          display: 'inline-flex',
          [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginRight: 8,
          },
        },
        caption: {
          color: textColor,
        },
        displayedRows: {
          color: textColor,
        },
        actions: {
          '& .MuiButtonBase-root': {
            color: blue[300], // İstediğiniz rengi burada belirleyin
          },
          '& .MuiButtonBase-root.Mui-disabled': {
            color: grey[300], // İstediğiniz rengi burada belirleyin
          },
        },
      },
    },

    MuiDataGrid: {
      styleOverrides: {
        menu: {
          zIndex: "50000000000 !important"
        },
        filterForm: {
          overflow: "auto",
          marginTop: "20px !important"
        },
        overlayWrapper: {
          width: "100%",
          height: "calc(100% - 62px)"
        },
        overlayWrapperInner: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100% !important"
        },
        /* virtualScroller: {
           overflowY: "visible !important",
           minHeight: "calc(100vh - 213px) !important"
         },*/
        cell: {
          '&.selected': {
            border: '2px solid blue !important',
            backgroundColor: 'rgba(173, 216, 230, 0.5)', // Açık mavi arka plan
            color: 'black', // Koyu metin rengi
            fontWeight: 'bold', // Kalın metin
          },
          '&.MuiDataGrid-cell--pinnedRight': {
            background: `#ffffff !important`, // Sol sabit hücreler için hover rengi
            backgroundColor: '#ffffff', // Remove background color
            '&:hover': {
              background: `#ffffff !important`, // Sol sabit hücreler için hover rengi
            },
          },
          '&.MuiDataGrid-cell--pinnedLeft': {
            background: `#ffffff !important`, // Sol sabit hücreler için hover rengi
            '&:hover': {
              background: `#ffffff !important`, // Sol sabit hücreler için hover rengi
            },
          },
          fontWeight: "500",
          border: "none",
          boxShadow: "0 0 0 0.3px #bfc7d9",
          '&:focus': {
            outline: 'none',
          },
        },
        columnHeader: {
          backgroundColor: '#ccd8f4',
        },
        columnHeaders: {
          borderBottom: '1px solid #ddd',
          color: textColor,
        },
        row: {
          '&.MuiDataGrid-row:hover': {
            background: `${btnHoverColor} !important`,
            cursor: "pointer",
            color: "inherit"
          },
        },
        columnHeaderRow: {
          backgroundColor: '#ccd8f4 !important',
        },
        headerFilterRow: {
          // backgroundColor: '#e6f4ff !important',
          borderTop: '1px solid #e0e0e0',
          height: "30px"
        },
        columnHeaderTitle: {
          color: textColor,
          fontWeight: 800,
        },
        columnHeaderTitleContainer: {
          // background: "red",
          display: 'flex',
          justifyContent: 'space-between', // Adjust positioning
          alignItems: 'center', // Center align items
        },
        iconButtonContainer: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: textColor
        },
        iconButton: {
          color: 'white', // Change icon button color to white
        },
        root: {
          padding: "20px !important",
          marginTop: '0px !important',
          /*  WebkitUserSelect: 'none',
           msUserSelect: 'none', 
           userSelect: 'none',  */
          borderColor: "#e0e0e0",
          backgroundColor: 'white', // Arka plan rengini beyaz yapar
          color: textColor,
          /* padding: "20px !important", */
          borderRadius: "5px",
          '& .MuiDataGrid-filler': {
            // height: '0px !important',
            height: "auto !important"
          },
          '& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon': {
            fontSize: '1.5rem',
            color: blue[900],
          },
          '& .MuiDataGrid-scrollbar--vertical': {
            overflow: 'hidden',
            '&::-webkit-scrollbar': {
              width: '4px '
            },
            '&::-webkit-scrollbar-track': {
              background: "#e0dede",
            },
            '&::-webkit-scrollbar-thumb': {
              background: "gray",
              borderRadius: '10px',
              border: '3px solid #808080',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: 'rgb(87, 84, 84)',
              cursor: 'pointer'
            },
          },

          '& .MuiDataGrid-footerContainer': {
            color: textColor,
            minHeight: 52,
            [theme.breakpoints.down('sm')]: {
              overflowX: 'hidden',
            },
          },
          '& .MuiTablePagination-selectLabel': {
            display: 'block !important',
            [theme.breakpoints.down('sm')]: {
              display: 'none !important',
            },
          },
          '& .MuiTablePagination-input': {
            display: 'inline-flex !important',
            [theme.breakpoints.down('sm')]: {
              marginLeft: '0 !important',
              marginRight: '8px !important',
            },
          },
          '& .MuiTablePagination-selectIcon': {
            display: 'block !important',
          },
          '& .MuiDataGrid-selectedRowCount': {
            color: textColor
          },
          '& .MuiDataGrid-virtualScroller': {
            borderRadius: '5px',
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          transition: 'width 1s',
          position: 'absolute',
          width: '200px',
          top: '50px',
          height: 'calc(100% - 40px)',
          background: "#e0dede",
          '&::-webkit-scrollbar': {
            width: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: "gray",
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            background: 'rgb(87, 84, 84)',
          },
        },
      },
    },
    /*     MuiIconButton: { burası data-grid headerdaki iconları bozuyor
          styleOverrides: {
            root: {
              width: 35,
              height: 35,
              color: "grey",
              position: 'absolute',
              top: '8px',
              left: '13px',
              zIndex: 100,
            },
          },
        }, */
    /*     MuiListItemButton: {
          styleOverrides: {
            root: {
              '&:hover': {
                color: theme.palette.common.white,
                backgroundColor: blue[900],
                '& .MuiListItemIcon-root': {
                  color: theme.palette.common.white,
                },
                '& .MuiTypography-root': {
                  color: theme.palette.common.white,
                },
                '&:hover .MuiSvgIcon-root': {
                  color: theme.palette.common.white,
                },
              },
            },
          },
        }, */
    MuiListSubheader: {
      styleOverrides: {
        root: {
          height: "50px",
          backgroundColor: theme.palette.common.white
        }
      }
    },
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        html: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        body: {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
        },
        '#root': {
          width: '100%',
          height: '100%',
          background: 'linear-gradient(to right, rgb(144, 162, 210), rgb(158, 223, 131))'
        },
        input: {
          '&[type=number]': {
            MozAppearance: 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        img: {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          borderRadius: "5px",
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: "40px !important",
          color: textColor
        },
      },
    },
    MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: `#5252528a !important`,
        },
        invisible: {
          background: 'transparent',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        startIcon: {
          '& > *:nth-of-type(1)': {
            fontSize: '16px', // İkon boyutu
          },
        },
        textPrimary: {
          border: '1px solid #bdbdbd', // Kenarlık rengi
          borderRadius: '4px', // Kenar yuvarlaklığı
          padding: '0 6px', // İç boşluk
          fontSize: '0.7rem !important', // Yazı boyutu
          '&:hover': {
            backgroundColor: '#90a2d2', // Hover durumunda arka plan rengi
          }
        },
        contained: {
          backgroundColor: blue[900],
          color: `${btnTextColor} !important`,
          height: "50px",
          cursor: "pointer",
        },
        outlined: {
          height: "50px",
          borderColor: "gray",
          color: "gray",
          '&:hover': {
            background: "gray",
            color: "white",
            borderColor: "gray",
            cursor: "pointer"
          }
        },
        root: {
          //vm
          '&.common-button': {
            '& .MuiTypography-root': {
              fontSize: '11px !important', // Typography boyutu
            },
            background: 'white',
            margin: "2px 3px",
            padding: "5px",
            gap: "5px",
            minWidth: "30px",
            border: "1px solid #bdbdbd",
            height: "20px",
            borderRadius: '3px !important',
            '&:hover': {
              backgroundColor: '#90a2d2', // Hover durumunda arka plan rengi
              color: 'white !important', // Hover durumunda metin rengi
            },
          },
          fontWeight: "600 !important",
          '&:hover': {
            background: 'linear-gradient(to right, rgb(144, 162, 210), rgb(158, 223, 131))',
            cursor: 'pointer',
          },
          height: "28px",
          marginTop: '2px',
          border: '1px solid #bdbdbd',
          marginRight: "3px",
          '&.Mui-disabled': {
            backgroundColor: 'gray',
            color: 'white',
            opacity: 0.5,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#F0F0F0",
          boxShadow: theme.customShadows.card,
          borderRadius: Number(theme.shape.borderRadius) * 2,
          position: 'relative',
          zIndex: 0,
        },
      },
    },
    MuiCardHeader: {
      defaultProps: {
        titleTypographyProps: { variant: 'h6' },
        subheaderTypographyProps: { variant: 'body2' },
      },
      styleOverrides: {
        root: {
          padding: theme.spacing(3, 3, 0),
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: blue[900],
          position: "relative",
          /* left: "-40px",
          top: "-23px" */
        }
      }
    },
    MuiPickersCalendarHeader: {
      styleOverrides: {
        label: {
          color: textColor
        },
      },
    },
    MuiPickersYear: {
      styleOverrides: {
        root: {
          color: textColor,
          '&:hover': {
            color: 'darkgreen', // Hover durumunda renk
          },
        },
      },
    },
    MuiPickersMonth: {
      styleOverrides: {
        monthButton: {
          color: textColor,
          '&:hover': {
            color: 'darkgreen', // Hover durumunda renk
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          paddingRight: "0px !important",
          fontWeight: 600,
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: textColor,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: textColor,
          },
          color: textColor,
          input: {
            '&.Mui-disabled': {
              /* opacity: 0.6, */
              // Disabled durumda metin rengini ve diğer stilleri özelleştirme
              color: textColor, // Metin rengini kırmızı yapar
              WebkitTextFillColor: textColor, // Webkit tarayıcıları için metin rengini kırmızı yapar
            },
          },
        },
        notchedOutline: {
          borderColor: theme.palette.grey[500],
        },
        color: textColor,
        input: {
          color: textColor, // Placeholder ve input metin rengi
        },
      },
    },
    /*   MuiAppBar: {
        styleOverrides: {
          root: {
            background: "linear-gradient(31deg, rgba(255, 255, 255) 0%, rgba(0, 42, 190, 0.5) 100%) !important"
          }
        }
      }, */
    MuiPaper: {
      styleOverrides: {
        root: {
          //background: "#fafafa",
          //background: "linear-gradient(31deg, rgba(255, 255, 255) 0%, rgba(0, 42, 190, 0.5) 100%) !important"

          //height: 'unset !important', // Yüksekliği iptal etmek için 'initial' olarak ayarlayın veya height özelliğini tamamen kaldırın
          // Diğer stil özellikleri buraya eklenebilir
        },
      },
      defaultProps: {
        elevation: 0,
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          paddingTop: "0px !important"
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },

    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: theme.palette.green[800],
        },
        arrow: {
          color: theme.palette.green[800],
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        fontWeight: "600 !important",
        color: `${textColor} !important`,
        paragraph: {
          marginBottom: theme.spacing(2),
        },
        gutterBottom: {
          marginBottom: theme.spacing(1),
        },
        root: {
          fontWeight: "600 !important",
          color: `${textColor} !important`,
          fontSize: "0.68rem"
        },
        overline: {
          color: `${blue[300]} !important`, // "Select time" yazısının rengi turkuaz (veya istediğiniz renk)
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          '& .MuiSvgIcon-root': {
            color: textColor, // SVG ikonlarının rengi beyaz
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: textColor,
          '&:hover .MuiTypography-root': {
            color: "white !important", // Hover durumunda içindeki span'ların text rengi
          },
          '&:hover .MuiSvgIcon-root': {
            color: '#fff !important',
          },
          '&:hover': {
            color: "white  !important", // Hover durumunda yazı rengini kırmızı yapar
            backgroundColor: "lightgray", // Hover durumunda arka plan rengini sarı yapar
          },
          '&.Mui-selected:hover': {
            color: 'blue', // Seçili öğe hover durumunda yazı rengini mavi yapar
            backgroundColor: 'lightgray', // Seçili öğe hover durumunda arka plan rengini açık gri yapar
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        color: textColor,
        root: {
          /* '&:hover': {
            color: 'red', // Hover durumunda yazı rengini kırmızı yapar
            backgroundColor: 'yellow', // Hover durumunda arka plan rengini sarı yapar
          }, */
          fontSize: "1.3rem",
          color: textColor,
          '&.MuiSelect-icon, &.MuiTablePagination-selectIcon, &.MuiSelect-iconStandard': {
            color: textColor,
          },
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          background: "white"
        }
      }
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          '&.custom-menu': {  // Target only the custom class
            top: '0px',
            '& .MuiPaper-root': {  // Target the paper component inside this menu
              top: '25px !important',
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              marginTop: '1.5em',
              borderRadius: '8px',
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                marginLeft: '-0.5em',
                marginRight: '1em',
              },
              '&::before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                backgroundColor: blue[900],
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          },
        },
      },
    },
    MuiPickersDay: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            color: '#ffffff !important',
          },
        },
        dayWithMargin: {
          backgroundColor: '#f0f0f0',
          color: '#000',
          '&.Mui-selected': {
            backgroundColor: blue[900],
            color: '#ffffff !important',
            '&:hover': {
              backgroundColor: blue[900],
            },
          },
          '&.Mui-disabled': {
            opacity: 0.4,
            color: '#bdbdbd',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          color: textColor,
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          margin: "0px !important"
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&:hover': {
            backgroundColor: '#f5f5f5', // Hover durumunda arka plan rengi
          },
          color: blue[300],
          '&.Mui-checked': {
            color: blue[300],
          },
          '&.MuiCheckbox-indeterminate': {
            color: blue[300],
          },
        },
      },
    },

    MuiPickersToolbar: {
      styleOverrides: {
        toolbar: {
          // "Select time" yazısının rengi beyaz yapılır
          color: blue[300] // Beyaz renk
        },
        selected: {
          // Seçilen saatin rengi
          color: '#FF5733 !important', // Seçilen saatin rengi kırmızı örneğin
        },
      },
    },
    MuiPickersToolbarText: {
      styleOverrides: {
        root: {
          // Saatin üzerindeki yazıların rengi beyaz yapılır
          color: blue[300] // Beyaz renk
        },
        selected: {
          // Seçilen saatin rengi
          color: 'red !important', // Seçilen saatin rengi kırmızı örneğin
        },
      },
    },
    MuiClockNumber: {
      styleOverrides: {
        root: {
          // Saat numaralarının varsayılan rengi
          color: blue[300] // Beyaz renk
        },
        selected: {
          // Seçilen saatin rengi
          color: 'yellow !important', // Seçilen saatin rengi kırmızı örneğin
        },
      },
    },
    MuiPickersArrowSwitcher: {
      styleOverrides: {
        button: {
          // Ok işaretlerinin rengi
          color: blue[300] // Beyaz renk
        },
        selected: {
          // Seçilen saatin rengi
          color: 'yellow !important', // Seçilen saatin rengi kırmızı örneğin
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          // Dialog (Aksiyon) butonlarının rengi
          color: blue[300] // Beyaz renk
        },
        selected: {
          // Seçilen saatin rengi
          color: 'yellow !important', // Seçilen saatin rengi kırmızı örneğin
        },
      },
    },

  };
}
